import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { openAiChat } from '@euler/app/flows/ai-suite/openAiChat';
import { aiSuiteToolForFeature } from '@euler/app/flows/ai-suite/theme';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { AiHomeFeature } from '@euler/model/ai-home';
import { StoreFeature } from '@euler/model/enum';
import { Text } from 'react-native';
import { BiDatasetLibraryView } from './library/list/BiDatasetLibraryView';

function BiDatasetLibrary() {
  const navigation = useAppNavigation();
  const mobile = useIsMobileLayout();
  return (
    <BiDatasetLibraryView
      mobile={mobile}
      onBack={() => navigation.goBack()}
      onOpen={datasetRef => navigation.navigate('BiDataset', { datasetRef })}
      onAskAi={() =>
        openAiChat(navigation, {
          kind: 'new',
          tool: aiSuiteToolForFeature(AiHomeFeature.BusinessIntelligence),
        })
      }
    />
  );
}

/** The data library: uploads, shared data and the built-in datasets. */
export const BiDatasetLibraryPage = wrapNavigatorScreen(
  () => {
    const profile = useUserProfileInfo();
    const bi = useStoreFeature(StoreFeature.Bi);
    if (!bi.enabled) return <FeatureNotEnabledView feature={StoreFeature.Bi} />;
    if (!profile?.user.enabled)
      return <Text>当前门店尚未开通经营分析，或账号不可用。</Text>;
    return <BiDatasetLibrary key={`${profile.org.id}:${profile.store.id}`} />;
  },
  { title: '我的数据', headerShown: false, headerMode: 'float' },
);
